import { render, staticRenderFns } from "./wxBindPhone.vue?vue&type=template&id=09bd0ada&"
import script from "./wxBindPhone.vue?vue&type=script&lang=js&"
export * from "./wxBindPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports